import script from "./PetugasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PetugasPage.vue?vue&type=script&setup=true&lang=js"

import "./PetugasPage.vue?vue&type=style&index=0&id=3ada77e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ada77e2"]])

export default __exports__